import { useTranslation } from 'react-i18next';
import { useAttachmentBlob } from '../hooks/useAttachmentBlob';
import styles from './ImageThumbnail.module.css';

interface IImageThumbnailProps {
  attachmentId: string;
  siteId: string;
  issueId: string;
  /** Optional pre-resolved local blob URL (e.g. for optimistic temp comments). When provided, skip the network fetch. */
  localBlobUrl?: string;
  onClick: (attachmentId: string) => void;
}

export function ImageThumbnail({ attachmentId, siteId, issueId, localBlobUrl, onClick }: IImageThumbnailProps) {
  const { t } = useTranslation();
  // Skip the fetch when we already have a local URL
  const remote = useAttachmentBlob(
    siteId,
    issueId,
    localBlobUrl ? null : attachmentId,
  );
  const url = localBlobUrl ?? remote.url;
  const isLoading = !localBlobUrl && remote.isLoading;
  const isError = !localBlobUrl && remote.isError;

  if (isLoading) {
    return <div className={styles.placeholder} aria-label={t('issues.hub.thumbnailLoading')} />;
  }
  if (isError || !url) {
    return (
      <div className={styles.errorBox} aria-label={t('issues.hub.thumbnailError')}>
        <span className={styles.errorIcon}>⚠</span>
      </div>
    );
  }
  return (
    <button
      type="button"
      className={styles.thumbButton}
      onClick={() => onClick(attachmentId)}
      aria-label={t('issues.hub.openImage')}
    >
      <img src={url} alt={t('issues.hub.commentImageAlt')} className={styles.img} />
    </button>
  );
}
